module.exports = "https://static.wmbcdn.com/uniweb/images/d354f0fa1b0ab65c7382df6923981bd4.svg";